import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { usePermissions } from "@/shared/hooks/usePermissions";

/**
 * Acesso restrito ao painel de controle do escritório:
 * controller, sócios e sócio gestor (master). Demais perfis são
 * redirecionados ao dashboard.
 */
const ControllerGuard = ({ children }: { children: React.ReactNode }) => {
  const { qualificacao, isMaster, loading } = usePermissions();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }

  const autorizado =
    isMaster || ["controller", "socio", "socio_gestor"].includes(qualificacao ?? "");

  if (!autorizado) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ControllerGuard;
